import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import Api from "services/api";
import { useTranslation } from "react-i18next";

const InterpreterJoinRoom = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const [iFrameURL, setiFrameURL] = useState();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const handleJoinVideoCall = async () => {
      if (!token) return;
      setLoading(true);
      try {
        const response = await Api.interpreterJoinRoomWithToken(token);
        if (response?.status === 200) {
          const iframeUrl = response?.data?.data?.iframe_url;
          setiFrameURL(iframeUrl);
          setLoading(false);
        } else {
          const errorMsg =
            response?.data?.error ||
            response?.data?.message ||
            t("appointments.errorJoiningVideoCall", "Failed to join video call");
          setErrorMessage(errorMsg);
          toast.error(errorMsg, { className: "errorToast" });
          setLoading(false);
        }
      } catch (err) {
        console.error("Error joining video call:", err);
        const errMsg =
          err?.response?.data?.error ||
          err?.message ||
          t("appointments.errorJoiningVideoCall", "Error joining video call");
        setErrorMessage(errMsg);
        toast.error(errMsg, { className: "errorToast" });
        setLoading(false);
      }
    };

    handleJoinVideoCall();
  }, [token]);

  return (
    <div
      className="container-fluid d-flex flex-column align-items-center justify-content-center bg-light p-0"
      style={{ width: "100%", height: "100vh", overflow: "hidden" }}
    >
      {loading ? (
        <p>Loading video call...</p>
      ) : iFrameURL ? (
        <iframe
          title="100ms-app"
          allow="camera *;microphone *;display-capture *"
          src={iFrameURL}
          className="w-100 h-100 border-0"
        ></iframe>
      ) : (
        <p>
          {errorMessage ||
            t("appointments.noVideoCallInProgress", "No video call in progress.")}
        </p>
      )}
    </div>
  );
};

export default InterpreterJoinRoom;
